import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import {  AdaptiveAccessControlNode, Header } from "@aptsi-types";

import { AdaptiveAccessNodeService } from "../adaptive-access-node/adaptive-access-node.service";
import { AccessFlowService } from "./access-flow.service";
import { Table } from "jspdf-autotable";
import { TableService } from "src/app/shared/table/table.service";


@Component({
  selector: 'app-terminate-dialog',
  template: `
  <div style="overflow:auto">
    <div class="row px-1 py-1">
    <div class="col text-end">
      <i class="bi bi-x-square-fill text-danger fs-3 " (click)="closeDialog()"></i>
    </div>
  </div>
    <div class="modal-header mx-5 pt-1 ">
      <h2 class="modal-title  w-100 fw-bold" style="font-weight: 500;" >Select Adaptive Access Nodes</h2>
      <button class="btn btn-success float-end mb-2" (click)="finish()">
        Confirm
      </button>
    </div>
    
    <!-- <hr> -->

    <div class="mx-5">
    
      <aptsi-table
      [haveUpdateDelete]="true"
      [haveCheck]="true"
      [haveUpdate]="false"
      [haveDelete]="false"
      [headers]="headers"
      [data]="adaptiveaccessnodes"
      [isClickDisabled]="true"
      [isCheckBoxEnabled]="true"
      [isRowSelected]="isCheckboxChecked"
      (selectionChanged)="onSelectionChanged($event)"
  >
  </aptsi-table>
    </div>
  </div>
    `,
})

export class AccessFlowNodePopupDialogComponent implements OnInit {

  clickedRows: number[] = [];
  existingAdptiveAccessNodeConfId: number = null;

  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { 
      title: string, 
      message: string, 
      digitalId: string,
      path: string,
      isCreate: string,
      organization: string, 
      pathoverride: string, 
      selectedEntries: any[]
    },
    private accessFlowService: AccessFlowService,
    private adaptiveAccessControlService: AdaptiveAccessNodeService,
    private tableService: TableService,
    private dialog: MatDialog
  ) {}

  headers: Header[] = [
    {
      name: 'Adaptive Access Node Id',
      property: 'adaptiveaccessnodeid',
      showInDropdown: true,
    }, 
    {
      name: 'Adaptive Access Node Type',
      property: 'adaptiveAccessNodeType',
      showInDropdown: true,
    },
    {
      name: 'Adaptive Access Node Name',
      property: 'adaptiveAccessNodeName',
      showInDropdown: true,
    },

  ];

  selectedEntries: AdaptiveAccessControlNode[] = [];
  adaptiveaccessnodes: AdaptiveAccessControlNode[] = [];

  async ngOnInit(): Promise<void> {
          if(this.data.isCreate){
          this.accessFlowService.selectedEntries$.subscribe(entries => {
            this.selectedEntries = [...entries]; // Create a new reference to trigger change detection
            console.log("selected entries in popup component for create:", this.selectedEntries);
          });
        }
        else if(!this.data.isCreate){
          this.accessFlowService.selectedEntries$.subscribe(entries => {
            this.selectedEntries = [...this.data.selectedEntries , ...entries]; // Create a new reference to trigger change detection
            console.log("selected entries in popup component for update:", this.selectedEntries);
          });
        }

    this.tableService.getCheckBox().subscribe(rows => {
      this.clickedRows = rows;
      console.log("Updated Clicked Rows:", this.clickedRows);
      this.selectEntries();  // Update selected entries based on checkbox selection
    });

    await this.fetchAdaptiveAccessNodes();  // Fetch data for nodes

    this.fetchAdaptiveAccessNodes().then(() => {
      // Find the indexes of selected entries in the data (this would correspond to checkbox selection)
      this.clickedRows = this.selectedEntries.map(entry =>
        this.adaptiveaccessnodes.findIndex(node => node.adaptiveaccessnodeid === entry.adaptiveaccessnodeid)
      );
  
      console.log("Updated Clicked Rows for pre-selection:", this.clickedRows);
  
      // Update table component with selected entries (this will pre-select checkboxes)
      this.tableService.updateClickedRows(this.clickedRows);  // Notify TableComponent to update checkboxes
    });
}

  async fetchAdaptiveAccessNodes() {
    try {
      const response = await this.adaptiveAccessControlService
        .getAllAdaptiveAccessNodes()
        .toPromise();
      const allNodes = response["Resource retrieved successfully"] || [];
  
      let latestSelectedEntries = this.accessFlowService.getFinalEntries();
      console.log("Latest selected entries:", latestSelectedEntries);
  
      this.selectedEntries = latestSelectedEntries.filter(selected =>
        allNodes.some(node => node.adaptiveaccessnodeid === selected.adaptiveaccessnodeid)
      );
  
      this.adaptiveaccessnodes = allNodes;
      console.log("Fetched nodes:", this.adaptiveaccessnodes);
      console.log("Updated selected entries after sync:", this.selectedEntries);
  
      // Activate checkboxes by comparing selectedEntries with the fetched data
      this.activateCheckboxes();
    } catch (error) {
      console.error("Error fetching adaptive access nodes:", error);
    }
  }

  activateCheckboxes() {
    // Activate checkboxes for selected entries
    this.clickedRows = this.adaptiveaccessnodes
      .map((node, index) => {
        if (this.selectedEntries.some(selected => selected.adaptiveaccessnodeid === node.adaptiveaccessnodeid)) {
          return index;  // This is the index of the selected node
        }
        return -1;  // This node is not selected
      })
      .filter(index => index !== -1);  // Remove non-selected indexes

    console.log("Clicked rows with activated checkboxes:", this.clickedRows);
    this.selectEntries();  // Update selected entries
  }

  

  onSelectionChanged(selectedIndexes: number[]) {
    console.log("Selection changed, selected indexes:", selectedIndexes);
  
    // Update the selected entries based on selected indexes
    this.selectedEntries = selectedIndexes.map(index => this.adaptiveaccessnodes[index]);
    console.log("Updated selected entries:", this.selectedEntries);
  }

  // Check if the checkbox should be checked for the row based on selected entries
  isCheckboxChecked(row: AdaptiveAccessControlNode): boolean {
    return this.selectedEntries.some(selected => selected.adaptiveaccessnodeid === row.adaptiveaccessnodeid);
  }

  selectEntries() {
    try {
      console.log("Selected indexes:", this.clickedRows);
      this.selectedEntries = this.clickedRows.map(index => {
        if (this.adaptiveaccessnodes[index]) {
          const node = this.adaptiveaccessnodes[index];
          console.log("Mapping index to node:", node);  // Ensure the index is valid
          return node;
        }
        return null;
      }).filter(node => node !== null);  // Filter out invalid nodes (if any)
  
      console.log("Updated selected entries:", this.selectedEntries);
    } catch (error) {
      console.error("Error updating selected entries:", error);
    }
  }

  finish() {
    console.log("Selected Entries Before Update:", this.selectedEntries);

    // Save the selected entries in the service before closing the dialog
    this.accessFlowService.setFinalEntries(this.selectedEntries);
    console.log("Final Entries Updated:", this.selectedEntries);
     this.closeDialog();
    
  }

  closeDialog(){
    this.dialog.closeAll();
  }
}



// export class AccessFlowNodePopupDialogComponent implements OnInit{

//   clickedRows: number[] = [];
//   existingAdptiveAccessNodeConfId: number= null;

//   constructor(
//     private router: Router, 
//     @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, digitalId: string , path:string ,isCreate:string, orgnization:string, pathoverride:string, selectedEntries: any[]},
//     private accessFlowService: AccessFlowService, private adaptiveAccessControlService: AdaptiveAccessNodeService, private tableService: TableService, private dialog: MatDialog) { 
//     //this.selectedEntries = data.selectedEntries || [];
//    }

  
//     headers: Header[] = [
//         {
//           name: 'Adaptive Access Node Id',
//           property: 'adaptiveaccessnodeid',
//           showInDropdown: true,
//         }, {
//           name: 'Adaptive Access Node Type',
//           property: 'adaptiveAccessNodeType',
//           showInDropdown: true,
//         }
//       ];
    
//       //selectedEntries: any[] = [];
//       selectedEntries: AdaptiveAccessControlNode[] =[];
//       //selectedEntries=this.data.selectedEntries;




//      // finalEntries: AdaptiveAccessControlNode[] = this.accessFlowService.getFinalEntries();
//       adaptiveaccessnodes: AdaptiveAccessControlNode[] = [];
//       nullver: number = null;
      

      
     
//       async ngOnInit(): Promise<void> {
//         if(this.data.isCreate){
//           this.accessFlowService.finalEntries$.subscribe(entries => {
//             this.selectedEntries = [...entries]; // Create a new reference to trigger change detection
//             console.log("selected entries in popup component for create:", this.selectedEntries);
//           });
//         }
//         else if(!this.data.isCreate){
//           this.accessFlowService.finalEntries$.subscribe(entries => {
//             this.selectedEntries = [...this.data.selectedEntries , ...entries]; // Create a new reference to trigger change detection
//             console.log("selected entries in popup component for update:", this.selectedEntries);
//           });
//         }

//         this.tableService.getCheckBox().subscribe(rows => {
//           this.clickedRows = rows;
//           console.log("Updated Clicked Rows:", this.clickedRows);
//           this.selectEntries();  // Update selected entries based on checkbox selection
//         });
        
      
//         await this.fetchAdaptiveAccessNodes();  // Fetch data for nodes
//         // Don't call selectEntries() here, it should be inside fetchAdaptiveAccessNodes()
//       }
      
//       async fetchAdaptiveAccessNodes() {
//         try {
//           const response = await this.adaptiveAccessControlService
//             .getAllAdaptiveAccessNodes()
//             .toPromise();
//           const allNodes = response["Resource retrieved successfully"] || [];
      
//           let latestSelectedEntries = this.accessFlowService.getFinalEntries();
//           console.log("Latest selected entries:", latestSelectedEntries);
      
//           this.selectedEntries = latestSelectedEntries.filter(selected =>
//             allNodes.some(node => node.adaptiveaccessnodeid === selected.adaptiveaccessnodeid)
//           );
      
//           this.adaptiveaccessnodes = allNodes;
//           console.log("Fetched nodes:", this.adaptiveaccessnodes);
//           console.log("Updated selected entries after sync:", this.selectedEntries);
      
//           // Call selectEntries here after the data is loaded
//           this.selectEntries();
      
//         } catch (error) {
//           console.error("Error fetching adaptive access nodes:", error);
//         }
//       }
      
      
//       onSelectionChanged(selectedIndexes: number[]) {
//         console.log("Selection changed, selected indexes:", selectedIndexes);
      
//         // Update the selected entries based on selected indexes
//         this.selectedEntries = selectedIndexes.map(index => this.adaptiveaccessnodes[index]);
//         console.log("Updated selected entries:", this.selectedEntries);
//       }
    
      
      
      
      
      
//       isCheckboxChecked(row: AdaptiveAccessControlNode): boolean {
//         return this.selectedEntries.some(selected => selected.adaptiveaccessnodeid === row.adaptiveaccessnodeid);
//       }

    
//       selectEntries() {
//         try {
//           console.log("Selected indexes:", this.clickedRows);
//           this.selectedEntries = this.clickedRows.map(index => {
//             if (this.adaptiveaccessnodes[index]) {
//               const node = this.adaptiveaccessnodes[index];
//               console.log("Mapping index to node:", node);  // Ensure the index is valid
//               return node;
//             }
//             return null;
//           }).filter(node => node !== null);  // Filter out invalid nodes (if any)
          
//           console.log("Updated selected entries:", this.selectedEntries);
//         } catch (error) {
//           console.error("Error updating selected entries:", error);
//         }
//       }

    
      
      

//       updateSelectedEntries(selectedIndexes: number[]) {
//         this.clickedRows = selectedIndexes;
//         this.selectedEntries = selectedIndexes.map(index => this.adaptiveaccessnodes[index]);
      
//         console.log("Updated selectedEntries:", this.selectedEntries);
//       }
      
      

//       finish() {
//         console.log("Selected Entries Before Update:", this.selectedEntries);
      
//         // Save the selected entries in the service before closing the dialog
//         this.accessFlowService.setFinalEntries(this.selectedEntries);
//         console.log("Final Entries Updated:", this.selectedEntries);
      
//         this.dialog.closeAll();
//       }
      
      
      
      
      
  
  

// }